import { render, staticRenderFns } from "./AddGlSubForm.vue?vue&type=template&id=6ce57a9a"
import script from "./AddGlSubForm.vue?vue&type=script&lang=js"
export * from "./AddGlSubForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports